import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import leaf from "../../Assets/Projects/screen1.png";
import emotion from "../../Assets/Projects/screen2.png";
import chatify from "../../Assets/Projects/screen0.png";
import chatapp from "../../Assets/Projects/Screen3.png";
import publicly from "../../Assets/Projects/Screen4.png"

function Projects() {
  return (
    <Container fluid className="project-section">
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Website for Food Catering Service"
              description="In March 2022, I initiated a consultancy project for a hotel, focusing on creating a dynamic website for their catering service. The website, developed using HTML, CSS, PHP, and MySQL, aimed to enhance online visibility and streamline catering operations. Leveraging these technologies, the project delivered a comprehensive and user-friendly platform for menu browsing, ordering, and inquiries."
              ghLink="https://github.com/dhinakaran2425/website-for-catering-service"
              demoLink="https://sribalajimessandbakery.000webhostapp.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="Doctor Appointment App - DocOnline"
              description="A Mobile Application to aid specialists to view the active appointments and update their availability, and patients to schedule appointments based upon the availability of specialists."
              ghLink="https://github.com/dhinakaran2425/Doctor-Appointment-App"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="SSE MERN Stack Project"
              description="The MERN Stack-based website developed for an electrical shop as a consultancy project serves as a comprehensive web solution. It integrates MongoDB, Express.js, React.js, and Node.js to provide a robust platform for the shop's online presence. The website likely includes features such as product listings, user authentication, shopping cart functionality, order management, and possibly additional custom functionalities tailored to the specific needs of the electrical shop. Through this project, a diverse set of skills in full-stack web development, database management, and frontend design were applied to create a professional and functional website suitable for real-world use."
              ghLink="https://github.com/dhinakaran2425/Sri-Selvanayagi-Electrical"
              demoLink="https://sri-selvanayagi-electrical.onrender.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatapp}
              isBlog={false}
              title="DS Chat Application"
              description="DS Chat Application is a real-time messaging platform for seamless and secure communication, featuring contact management, instant messaging, and a user-friendly interface."
              ghLink="https://github.com/dhinakaran2425/DS-ChatApplication"
              demoLink="https://ds-chatapplication-1.onrender.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={publicly}
              isBlog={false}
              title="Publicly"
              description="Publicly is a social networking app designed to help users connect with peoples. Whether you're looking to make new friends, or aiming to engage with like-minded individuals in your vicinity, Publicly facilitates these connections. The app enables instant discovery and interaction with people around globe, enhancing your social experience. "
              ghLink="https://github.com/dhinakaran2425/publicly"
              demoLink="https://publicly.vercel.app/"
            />
          </Col>

        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
